import React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForIntl, registerForLocalization } from '@progress/kendo-react-intl';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Grid } from '../../shared/components';
import { Text } from '../../../ui';
import { closeStudyProgramSkillAbilityConfirmDialog, loadStudyProgramSkillAbilityList, openStudyProgramSkillAbilityConfirmDialog, removeStudyProgramSkillAbilityConfirmDialog } from '../actions/study-program-skill-ability-list-actions';
import { withRouter } from '../../../components/withRouter';

class StudyProgramSkillAbilityList extends React.Component {
  constructor(props) {
    super(props);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
    this.handleConfirmDialogClose = this.handleConfirmDialogClose.bind(this);
    this.handleRemoveConfirm = this.handleRemoveConfirm.bind(this);
  }

  async componentDidMount() {
    await this.props.loadStudyProgramSkillAbilityList({
      studyProgramId: this.props.studyProgramId
    });
  }

  render() {
    const { studyProgramSkillAbilities, loading, isConfirmDialogVisible, canWrite } = this.props;
    const localizationService = provideLocalizationService(this);
    return (
      <>
        <Grid
          loading={loading}
          data={studyProgramSkillAbilities}
          isPageable={false}
          columns={[
            {
              field: 'name',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('studyProgram.name')
            }
          ]}
          actions={
            canWrite &&
          [
            { icon: 'edit', onClick: this.handleEditClick },
            { icon: 'delete', onClick: this.handleRemoveClick }
          ]}
        />
        {isConfirmDialogVisible &&
          <Dialog title={localizationService.toLanguageString('custom.confirm')} onClose={this.handleConfirmDialogClose}>
            <Text>{`${localizationService.toLanguageString('studyProgram.studyProgramSkillAbilityDialogMessage')} ${this.props.selectedStudyProgramSkillAbilityAssignedCount}`}</Text>
            <DialogActionsBar>
              <Button themeColor={'primary'} onClick={this.handleRemoveConfirm}>{localizationService.toLanguageString('buttons.delete')}</Button>
              <Button onClick={this.handleConfirmDialogClose}>{localizationService.toLanguageString('buttons.cancel')}</Button>
            </DialogActionsBar>
          </Dialog>
        }
      </>
    );
  }

  handleEditClick(row) {
    this.props.navigate(`/study_programs/${this.props.studyProgramId}/skill_abilities/${row.dataItem.id}`);
  }

  handleRemoveClick(e) {
    this.props.openStudyProgramSkillAbilityConfirmDialog(e.dataItem);
  }

  handleConfirmDialogClose() {
    this.props.closeStudyProgramSkillAbilityConfirmDialog();
  }

  handleRemoveConfirm() {
    this.props.removeStudyProgramSkillAbilityConfirmDialog({
      studyProgramId: this.props.studyProgramId
    });
  }
}

const mapStateToProps = (state) => ({
  studyProgramSkillAbilities: state.studyProgramSkillAbilityList.studyProgramSkillAbilities,
  loading: state.studyProgramSkillAbilityList.loading,
  isConfirmDialogVisible: state.studyProgramSkillAbilityList.isConfirmDialogVisible,
  selectedStudyProgramSkillAbilityAssignedCount: state.studyProgramSkillAbilityList.selectedStudyProgramSkillAbilityAssignedCount,
  canWrite: state.studyProgramSkillAbilityList.canWrite
});

const mapDispatchToProps = (dispatch) => ({
  loadStudyProgramSkillAbilityList: (payload) => dispatch(loadStudyProgramSkillAbilityList(payload)),
  openStudyProgramSkillAbilityConfirmDialog: (payload) => dispatch(openStudyProgramSkillAbilityConfirmDialog(payload)),
  closeStudyProgramSkillAbilityConfirmDialog: (payload) => dispatch(closeStudyProgramSkillAbilityConfirmDialog(payload)),
  removeStudyProgramSkillAbilityConfirmDialog: (payload) => dispatch(removeStudyProgramSkillAbilityConfirmDialog(payload))
});

registerForIntl(StudyProgramSkillAbilityList);
registerForLocalization(StudyProgramSkillAbilityList);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StudyProgramSkillAbilityList));
